import JobSearchBanner from "../jobSearchBanner";
import socialIcon from "../../images/icons/facebook-logo.png.png";
export default function CareerOpportunity() {
  const details = [
    {
      modal: "Remote",
      salary: "$4,000 - $5,000",
      location: "Australia",
    },
  ];
  const jobs = [
    {
      icon: socialIcon,
      label: "AI Specialist",
      description:
        "Develop AI solutions, analyze data, and optimize machine learning models to drive innovation.",
      details: details,
    },
    {
      icon: socialIcon,
      label: "AI Specialist",
      description:
        "Develop AI solutions, analyze data, and optimize machine learning models to drive innovation.",
      details: details,
    },
    {
      icon: socialIcon,
      label: "AI Specialist",
      description:
        "Develop AI solutions, analyze data, and optimize machine learning models to drive innovation.",
      details: details,
    },
    {
      icon: socialIcon,
      label: "AI Specialist",
      description:
        "Develop AI solutions, analyze data, and optimize machine learning models to drive innovation.",
      details: details,
    },
    {
      icon: socialIcon,
      label: "AI Specialist",
      description:
        "Develop AI solutions, analyze data, and optimize machine learning models to drive innovation.",
      details: details,
    },
  ];

  return (
    <div className="p-8 md:p-[70px]bg-soft-rose ">
      <div className="max-w-[1500px] mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {jobs?.map((job, index) => (
          <JobSearchBanner
            icon={job.icon}
            label={job.label}
            description={job.description}
            details={job.details}
          />
        ))}
      </div>
    </div>
  );
}
